import api from '@/api';
import request from '@/lib/request';
import _ from 'lodash';
// import { Message } from 'element-ui';

export const getAuthInfo = async () => {
  const { res } = await request.get(api.omg.publicInfo.GET_AUTH_LIST, {});
  return _.get(res, 'data');
};


export const getConfigInfo = async () => {
  const { res } = await request.get(api.omg.publicInfo.GET_CONFIG_INFO, {});
  return res;
};
